export const navigationLinks = [
    {
        name: 'HOME',
        ref: '#home'
    },
    {
        name: 'ABOUT ME',
        ref: '#about-me'
    },
    {
        name: 'TECHNOLOGIES',
        ref: '#technologies'
    },
    {
        name: 'PORTFOLIO',
        ref: '#portfolio'
    },
    {
        name: 'CONTACT',
        ref: '#contact'
    },
]